module.exports = __webpack_public_path__ + "img/logo-openrice-en.3787f75a.jpg";